import store from '../store/index';

const GA_TYPES = {
  GA4: 'GA4',
  GA_UA: 'GA_UA',
};

export const DataLayerManager = {

  pushEventToDataLayer(eventData) {
    window.dataLayer.push({
      ecommerce: null,
    });
    window.dataLayer.push(eventData);
  },

  pushAddToCartEvent(product, quantity) {
    const GAProduct = DataLayerManager.getProductAsGAItem(product);
    const UAProduct = DataLayerManager.getProductAsUAItem(product);

    if (quantity !== undefined) {
      GAProduct.quantity = quantity;
      UAProduct.quantity = quantity;
    }

    const eventData = {
      event: 'add_to_cart',
      currency: 'PLN',
      ecommerce: {
        items: [
          GAProduct,
        ],
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      items: [{
        id: DataLayerManager.getProductGAId(product),
        google_business_vertical: 'retail',
      }],
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventDataUA = {
      event: 'add_to_cart_UA',
      ecommerce: {
        currencyCode: 'PLN',
        add: {
          products: [
            UAProduct,
          ],
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      items: [{
        id: DataLayerManager.getProductUAId(product),
        google_business_vertical: 'retail',
      }],
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventDataUA);
  },

  pushRemoveCartEvent(product, quantity) {
    const GAProduct = DataLayerManager.getProductAsGAItem(product);
    const UAProduct = DataLayerManager.getProductAsUAItem(product);

    if (quantity !== undefined) {
      GAProduct.quantity = quantity;
      UAProduct.quantity = quantity;
    }

    const eventData = {
      event: 'remove_from_cart',
      currency: 'PLN',
      ecommerce: {
        items: [
          GAProduct,
        ],
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      items: [{
        id: DataLayerManager.getProductGAId(product),
        google_business_vertical: 'retail',
      }],
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventDataUA = {
      event: 'remove_from_cart_UA',
      ecommerce: {
        remove: {
          products: [
            UAProduct,
          ],
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventDataUA);
  },

  pushBeginCheckoutEvent() {
    const eventData = {
      event: 'begin_checkout',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventDataUA = {
      event: 'begin_checkout_UA',
      ecommerce: {
        currencyCode: 'PLN',
        checkout: {
          actionField: {
            step: 1,
            option: 'Begin Checkout',
          },
          products: DataLayerManager.getItemsFromCartUA(),
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };

    DataLayerManager.pushEventToDataLayer(eventDataUA);
  },

  pushAddShippingInfoEvent() {
    const eventData = {
      event: 'add_shipping_info',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        shipping_tier: 1,
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventDataUA = {
      event: 'add_shipping_info_UA',
      currencyCode: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      affiliation: 'Online Store',
      ecommerce: {
        checkout: {
          actionField: {
            step: 4,
            option: 'Add Shipping Info',
          },
          products: DataLayerManager.getItemsFromCartUA(),
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventDataUA);
  },

  pushAddPaymentInfoEvent() {
    const eventData = {
      event: 'add_payment_info',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        payment_type: '',
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      items: DataLayerManager.getItemsFromCartGA4Remarketing(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventDataUA = {
      event: 'add_payment_info_UA',
      currencyCode: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      payment_type: '',
      affiliation: 'Online Store',
      ecommerce: {
        checkout: {
          actionField: {
            step: 3,
            option: 'Add Payment Info',
          },
          products: DataLayerManager.getItemsFromCartUA(),
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventDataUA);
  },

  pushSelectItemEvent() {
    const eventData = {
      event: 'select_item',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);
  },

  pushViewCartEvent() {
    const eventData = {
      event: 'view_cart',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);
  },

  pushCheckoutStep2Event() {
    const eventData = {
      event: 'checkout_step_2',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventDataUA = {
      event: 'checkout_step_2_UA',
      currencyCode: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      affiliation: 'Online Store',
      ecommerce: {
        checkout: {
          actionField: {
            step: 2,
            option: 'Login',
          },
          products: DataLayerManager.getItemsFromCartUA(),
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventDataUA);
  },

  pushCheckoutStep5Event() {
    const eventData = {
      event: 'checkout_step_5',
      currency: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      ecommerce: {
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);

    const eventData_UA = {
      event: 'checkout_step_5_UA',
      currencyCode: 'PLN',
      value: store.getters['cart/getGrossSummary'],
      affiliation: 'Online Store',
      ecommerce: {
        checkout: {
          actionField: {
            step: 5,
            option: 'Summary',
          },
          products: DataLayerManager.getItemsFromCartUA(),
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData_UA);
  },

  pushVirtualPageViewEvent() {
    const eventData = {
      event: 'virtual_page_view',
      page: '',
      pageTitle: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);
  },

  pushButtonOrderClickEvent() {
    const eventData = {
      event: 'button_order_click',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);
  },

  pushPurchaseEvent(orderId) {
    const eventData = {
      event: 'purchase',
      ecommerce: {
        transaction_id: orderId,
        affiliation: 'Online Store',
        value: store.getters['cart/getGrossSummary'],
        tax: store.getters['cart/getTax'],
        shipping: store.getters['cart/getShippingCost'],
        currency: 'PLN',
        coupon: '',
        items: DataLayerManager.getItemsFromCartGA4(),
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
      items: DataLayerManager.getItemsFromCartAsRemarketing(GA_TYPES.GA4),
    };
    DataLayerManager.pushEventToDataLayer(structuredClone(eventData));

    const eventDataUA = {
      event: 'purchase_UA',
      ecommerce: {
        currencyCode: 'PLN',
        purchase: {
          actionField: {
            id: orderId,
            affiliation: 'Online Store',
            revenue: store.getters['cart/getGrossSummary'],
            tax: store.getters['cart/getTax'],
            shipping: store.getters['cart/getShippingCost'],
          },
          products: DataLayerManager.getItemsFromCartUA(),
        },
      },
      cart_id: '',
      user_id: DataLayerManager.getUserId(),
      user_logged: DataLayerManager.getUserLogged(),
      items: DataLayerManager.getItemsFromCartAsRemarketing(GA_TYPES.GA_UA),
    };
    DataLayerManager.pushEventToDataLayer(structuredClone(eventDataUA));
  },

  pushLoginEvent() {
    const eventData = {
      event: 'login',
      user_id: DataLayerManager.getUserId(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);
  },

  pushSignUpEvent() {
    const eventData = {
      event: 'sign_up',
      user_id: DataLayerManager.getUserId(),
    };
    DataLayerManager.pushEventToDataLayer(eventData);
  },

  getProductAsGAItem(product) {
    const basicInfo = {
      quantity: product.quantity,
      price: product.price,
      currency: 'PLN',
    };
    if (!product.analyticsData) return basicInfo;
    return {
      item_name: product.analyticsData.GA4.item_name,
      item_id: product.analyticsData.GA4.item_id,
      item_brand: product.analyticsData.GA4.item_brand,
      item_variant: product.analyticsData.GA4.item_variant,
      item_variant_id: product.analyticsData.GA4.item_variant_id,
      item_category: product.analyticsData.GA4.item_category,
      item_category2: product.analyticsData.GA4.item_category2,
      item_category3: product.analyticsData.GA4.item_category3,
      item_category4: product.analyticsData.GA4.item_category4,
      item_category5: product.analyticsData.GA4.item_category5,
      ...basicInfo,
    };
  },

  getProductGAId(product) {
    return product.analyticsData.GA4.item_id;
  },

  getProductUAId(product) {
    return product.analyticsData.GA_UA.id;
  },

  getProductAsUAItem(product) {
    const basicInfo = {
      price: product.price,
      quantity: product.quantity,
    };
    if (!product.analyticsData) return basicInfo;
    return {
      name: product.analyticsData.GA_UA.name,
      id: product.analyticsData.GA_UA.id,
      brand: product.analyticsData.GA_UA.brand,
      variant: product.analyticsData.GA_UA.variant,
      variant_id: product.analyticsData.GA_UA.variant_id,
      category: product.analyticsData.GA_UA.category,
      category2: product.analyticsData.GA_UA.category2,
      category3: product.analyticsData.GA_UA.category3,
      category4: product.analyticsData.GA_UA.category4,
      category5: product.analyticsData.GA_UA.category5,
      ...basicInfo,
    };
  },

  getItemsFromCartGA4() {
    return store.getters['delivery/getItemsAll'].map(product => DataLayerManager.getProductAsGAItem(product));
  },

  getItemsFromCartUA() {
    return store.getters['delivery/getItemsAll'].map(product => DataLayerManager.getProductAsUAItem(product));
  },

  getItemsFromCartAsRemarketing(type) {
    return store.getters['delivery/getItemsAll'].map(product => DataLayerManager.getProductAsRemarketingItem(product, type));
  },

  getProductAsRemarketingItem(product, type) {
    if (!product.analyticsData) return {};
    const key = type === GA_TYPES.GA4 ? 'item_id' : 'id';
    return {
      id: product.analyticsData[type][key],
      google_business_vertical: 'retail',
    };
  },

  getItemsFromCartGA4Remarketing() {
    const items = DataLayerManager.getItemsFromCartGA4();
    return items.map(item => ({ id: item.item_id, google_business_vertical: 'retail' }));
  },

  getUserId() {
    return store.getters['cart/getUserId'] === -1 ? '' : store.getters['cart/getUserId'];
  },

  getUserLogged() {
    return !store.getters['cart/getUserIsGuest'];
  },
};
